import { apiCallCenter, apiClientGeral } from '@/plugins/axios'

export default {
  getWebhooks() {
    return apiCallCenter().get('/webhook')
  },
  getWebhook(id) {
    return apiCallCenter().get(`/webhook/${id}`)
  },
  updateWebhookActiveStatus(id, status) {
    return apiCallCenter().put(`/webhook/updatestatus/${id}`, { ativo: status })
  },
  getRotas() {
    return apiClientGeral().get('/rotas')
  },
  getFilas() {
    return apiCallCenter().get('/queue/lazy')
  },
  getOperadores() {
    return apiCallCenter().get('/agent/lazy')
  },
  postWebhooks(webhook) {
    return apiCallCenter().post('/webhook', webhook)
  },
  putWebhooks(webhook, id) {
    return apiCallCenter().put(`/webhook/${id}`, webhook)
  },
  deleteWebhooks(id) {
    return apiCallCenter().delete(`/webhook/${id}`)
  },
  getGruposDeRotas() {
    return apiClientGeral().get('/grupo-rotas')
  }
}
